<template>
<div class="container">
  <div class="home-right__bottom">
    <div class="home-right__bottom__title">健康宣传
    <span class="con-span"  @click="toList(zlList[0].id)">更多></span>
    </div>
    <img
      v-for="(item,index) in images"
      :key="index"
      v-if="index<3"
      :src="item.thumbnail" alt="出错" @click="towin(item.id)">
  </div>
</div>
</template>

<script>
export default {
  name: "Topic",
  props:{
    zlList:{
      type:Array
    }
  },
  data(){
    return{
      images:[]
    }
  },
  watch:{
    zlList:function (){
      this.images=this.zlList[0].content
    }
  },
  methods:{
    toList(id){
      this.$router.push(`/news/${id}`)
    },
    towin(id){
      this.$router.push(`/content/${id}`)
    }
  }
}
</script>

<style scoped>
.container{
  background-color: white;
  margin-top: 20px;
  padding: 10px 10px;
 box-sizing: border-box;
}
.home-right__bottom__title{
  position: relative;
  padding: 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #d0d0d0;
  color: #088A29;
  line-height: 30px;
  font-weight: 900;
  font-size: 20px;
}
.con-span{
  position: absolute;
  right: 0;
  bottom: 3px;
  cursor: pointer;
  color: #303133;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.con-span:hover{
  color: #088A29;
  text-decoration: underline;
}
.home-right__bottom img{
  width: 32%;
  margin-right: 10px;
}
.home-right__bottom img:last-child{
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Topic.vue